import { create, show, useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import Typography from "ds/components/Typography";

import ConfirmationModal from "../ConfirmationModal";

type RefreshSecretConfirmationModalProps = {
  onConfirm: () => Promise<boolean>;
  onClose?: () => void;
};

const RefreshSecretConfirmationModal = create(function RefreshSecretConfirmationModal({
  onConfirm,
  onClose,
}: RefreshSecretConfirmationModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const modal = useModal();

  const handleConfirm = () => {
    setIsLoading(true);
    onConfirm()
      .then((success) => {
        if (success) {
          modal.hide();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ConfirmationModal
      title="Regenerate secret"
      confirmationButtonLabel="Regenerate"
      isLoading={isLoading}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <ConfirmationModalMessage>
        Are you sure you want to regenerate the secret?
      </ConfirmationModalMessage>
      <br />
      <Typography tag="p">
        This action will regenerate the secret and all its use cases will need to be updated.
      </Typography>
    </ConfirmationModal>
  );
});

export const showRefreshSecretConfirmationModal = (props: RefreshSecretConfirmationModalProps) =>
  show(RefreshSecretConfirmationModal, props);
